import React, { useContext, useState, useEffect } from 'react';
import AuthContext from 'app/src/contexts/AuthContext';
import ChatModal from 'app/src/elements/Modal/ChatModal';
import ConversationsModal from 'app/src/elements/Modal/ConversationsModal';
import Conversation from 'app/src/components/Conversations/Conversation';
import {
  CollapsedChat,
  ChatContainer,
  ChatBoxes,
} from 'app/src/elements/Modal/elements';

import {
  Text,
  View
} from 'react-native';
import MessageInputContext from 'app/src/contexts/MessageInputContext';
import PendingConversations from 'app/src/components/Conversations/PendingConversations';
import { createPortal } from 'react-dom';

const Chat = () => {
  const {
    showModal,
    setShowModal,
    pendingResponseIds,
    openIds,
    collapsedIds,
    removeFromCollapsed,
    getConversationBuyerName,
  } = useContext(MessageInputContext);
  const [showConversations, setShowConversations] = useState(false);

  return (
    createPortal(

      <ChatContainer>
        <PendingConversations
          showConversations={showConversations}
          setShowConversations={setShowConversations}
          pendingConversations={pendingResponseIds?.length > 0}
          openConversations={openIds?.length}
        />
        <ChatBoxes
          showConversations={showConversations}
          pendingConversations={pendingResponseIds?.length > 0}
          openConversations={openIds?.length}
        >
          {openIds?.map(id => {
            return (
              <>
                {collapsedIds.includes(id) ?
                  <CollapsedChat
                    key={`collapsed-${id}`}
                    onPress={() => removeFromCollapsed(id)}
                    pendingResponse={pendingResponseIds.includes(id)}
                  >
                    <Text style={{color: '#fff', fontWeight: 'bold'}}>
                      {`${getConversationBuyerName(id)}`}
                    </Text>
                  </CollapsedChat> :
                  <div id='chat-box'>
                    <ChatModal
                      showModal={showModal}
                      setShowModal={setShowModal}
                      modalType={getConversationBuyerName(id)}
                      conversationId={id}
                      pendingResponse={pendingResponseIds.includes(id)}
                    >
                      <Conversation
                        setShowModal={setShowModal}
                        conversationId={id}
                        key={`conversation-${id}`}
                        name={`conversation-${id}`}
                      />
                    </ChatModal>
                  </div>
                }
              </>
            )
          })}
        </ChatBoxes>
      </ChatContainer>, document.body
    )
  )
}

export default Chat;